/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_soldil_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Work out exactly how much stock solution and diluent you need. Enter any three values and leave the one you want to find blank — the calculator solves it using C1V1 = C2V2.`)
};

const es_soldil_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcula exactamente cuánta solución madre y diluyente necesitas. Introduce tres valores cualesquiera y deja en blanco el que quieras calcular — la calculadora lo resuelve usando C1V1 = C2V2.`)
};

const de_soldil_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berechnen Sie genau, wie viel Stammlösung und Verdünnungsmittel Sie benötigen. Geben Sie drei beliebige Werte ein und lassen Sie das gesuchte Feld leer — der Rechner löst es mit C1V1 = C2V2.`)
};

const nl_soldil_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereken precies hoeveel stockoplossing en verdunningsmiddel je nodig hebt. Vul drie waarden in en laat het veld dat je wilt berekenen leeg — de calculator lost het op met C1V1 = C2V2.`)
};

const fr_soldil_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déterminez exactement la quantité de solution mère et de diluant nécessaire. Entrez trois valeurs et laissez vide celle que vous souhaitez trouver — le calculateur la résout avec C1V1 = C2V2.`)
};

const it_soldil_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcola esattamente quanta soluzione madre e diluente ti servono. Inserisci tre valori qualsiasi e lascia vuoto quello che vuoi trovare — il calcolatore lo risolve usando C1V1 = C2V2.`)
};

const pt_br2_soldil_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descubra exatamente quanto de solução estoque e diluente você precisa. Informe três valores e deixe em branco o que deseja encontrar — a calculadora resolve usando C1V1 = C2V2.`)
};

const pt_soldil_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcule exatamente quanta solução-mãe e diluente precisa. Introduza quaisquer três valores e deixe em branco o que pretende calcular — a calculadora resolve-o usando C1V1 = C2V2.`)
};

const ja_soldil_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`必要なストック溶液と希釈剤の量を正確に計算します。3つの値を入力し、求めたい項目は空欄のままにしてください — 計算ツールが C1V1 = C2V2 を使って解きます。`)
};

const zh_soldil_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`精确计算所需的母液和稀释剂用量。输入任意三个数值，将要求解的字段留空——计算器会用 C1V1 = C2V2 求解。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const soldil_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.soldil_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("soldil_intro", locale)
	if (locale === "en") return en_soldil_intro(inputs)
	if (locale === "es") return es_soldil_intro(inputs)
	if (locale === "de") return de_soldil_intro(inputs)
	if (locale === "nl") return nl_soldil_intro(inputs)
	if (locale === "fr") return fr_soldil_intro(inputs)
	if (locale === "it") return it_soldil_intro(inputs)
	if (locale === "pt-BR") return pt_br2_soldil_intro(inputs)
	if (locale === "pt") return pt_soldil_intro(inputs)
	if (locale === "ja") return ja_soldil_intro(inputs)
	return zh_soldil_intro(inputs)
};